import { SVGProps } from 'react';

const ChevronsLeftRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m9 7-5 5 5 5m6-10 5 5-5 5"
    />
  </svg>
);
export default ChevronsLeftRight;
